<div class="format-view-shared_field" [formGroup]="formGroup()">
  <div class="localized-field_label-wrapper">
    <span class="format-view-shared_field-label">
      {{ (formGroup().controls.en | wrapFn: hasRequiredValidator) ? '*' : '' }} {{ 'FORMAT_VIEW_DIALOG.' + fieldName() + '_LABEL' | translate }} -
      {{ 'LANGUAGE.EN' | translate }}
    </span>
    <language-chooser
      [activeLanguages]="activeLanguages()"
      [availableLanguages]="availableLanguages"
      [defaultLanguage]="'en'"
      (activeLanguagesChanged)="activeLanguagesChanged($event)"></language-chooser>
  </div>
  <ng-template [ngTemplateOutlet]="localizedFieldTemplate" [ngTemplateOutletContext]="{ locale: 'en' }" />
  @for (locale of formGroup().controls | keyvalue; track locale.key) {
    @if (locale.key !== 'en') {
      <span class="format-view-shared_field-label">{{ 'LANGUAGE.' + locale.key | uppercase | translate }}</span>
      <ng-template [ngTemplateOutlet]="localizedFieldTemplate" [ngTemplateOutletContext]="{ locale: locale.key }" />
    }
  }

  <ng-template #localizedFieldTemplate let-locale="locale">
    <mat-form-field celum-form-field size="large" [reserveHintSpace]="true">
      @if (inputType() === 'input') {
        <input
          matInput
          type="text"
          [attr.data-test-localized-field-input]="fieldName()"
          [formControlName]="locale"
          [maxLength]="validationLimit()"
          [placeholder]="placeholder() ?? 'FORMAT_VIEW_DIALOG.' + fieldName() + '_PLACEHOLDER' | translate" />
      } @else {
        <textarea
          matInput
          [attr.data-test-localized-field-input]="fieldName()"
          [formControlName]="locale"
          [maxLength]="validationLimit()"
          [placeholder]="placeholder()"></textarea>
      }
      @if (validationLimit() - formGroup().get(locale).value.length <= 10) {
        <mat-hint [attr.data-test-localized-field-hint]="fieldName()">
          {{ 'INPUT_HINTS.REMAINING_CHARS' | translate: { remaining: validationLimit() - formGroup().get(locale).value.length } }}
        </mat-hint>
      }
      @if (formGroup().get(locale).errors?.['required']) {
        <mat-error [attr.data-test-localized-field-error-required]="fieldName()">{{ 'VALIDATION.REQUIRED' | translate }}</mat-error>
      }
      @if (formGroup().get(locale).errors?.['maxlength']) {
        <mat-error [attr.data-test-localized-field-error-maxlength]="fieldName()">
          {{ 'VALIDATION.MAX_LENGTH' | translate: { maxLength: validationLimit() } }}
        </mat-error>
      }
    </mat-form-field>
  </ng-template>
</div>
